<template>
  <div class="secondary--text filter-options filter-options--influencer-discovery">
    <v-row>
      <v-col
        v-for="item in platformFilters"
        :key="'platform-' + item"
        cols="6"
        sm="4"
        md="3"
        lg="2"
      >
        <component
          :is="item"
          :platform="platform"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// const FilterAudienceType = () => import("@/blocks/influencer-discovery/FilterAudienceType.vue")
const FilterAudienceCredibilityClass = () => import("@/blocks/influencer-discovery/FilterAudienceCredibilityClass.vue")
// const FilterAccountType = () => import("@/blocks/influencer-discovery/FilterAccountType.vue")
const FilterPartnership = () => import("@/blocks/influencer-discovery/FilterPartnership.vue")
const FilterEngagements = () => import("@/blocks/influencer-discovery/FilterEngagements.vue")
const FilterLastPosted = () => import("@/blocks/influencer-discovery/FilterLastPosted.vue")
const FilterLookAlike = () => import("@/blocks/influencer-discovery/FilterLookAlike.vue")
const FilterFollowers = () => import("@/blocks/influencer-discovery/FilterFollowers.vue")
const FilterReelViews = () => import("@/blocks/influencer-discovery/FilterReelViews.vue")
const FilterLocation = () => import("@/blocks/influencer-discovery/FilterLocation.vue")
const FilterLanguage = () => import("@/blocks/influencer-discovery/FilterLanguage.vue")
const FilterInterest = () => import("@/blocks/influencer-discovery/FilterInterest.vue")
const FilterContacts = () => import("@/blocks/influencer-discovery/FilterContacts.vue")
const FilterKeywords = () => import("@/blocks/influencer-discovery/FilterKeywords.vue")
const FilterTextTags = () => import("@/blocks/influencer-discovery/FilterTextTags.vue")
// const FilterOfficial = () => import("@/blocks/influencer-discovery/FilterOfficial.vue")
const FilterGender = () => import("@/blocks/influencer-discovery/FilterGender.vue")
const FilterGrowth = () => import("@/blocks/influencer-discovery/FilterGrowth.vue")
const FilterBrand = () => import("@/blocks/influencer-discovery/FilterBrand.vue")
const FilterViews = () => import("@/blocks/influencer-discovery/FilterViews.vue")
const FilterAge = () => import("@/blocks/influencer-discovery/FilterAge.vue")
const FilterBio = () => import("@/blocks/influencer-discovery/FilterBio.vue")

export default {
  name: "FilterOptions",

  props: {
    platform: {
      type: String,
      required: true
    }
  },

  components: {
    // FilterAudienceType,
    FilterAudienceCredibilityClass,
    // FilterAccountType,
    FilterPartnership,
    FilterEngagements,
    FilterLastPosted,
    FilterFollowers,
    FilterReelViews,
    FilterLookAlike,
    FilterInterest,
    FilterLocation,
    FilterLanguage,
    FilterContacts,
    FilterKeywords,
    FilterTextTags,
    // FilterOfficial,
    FilterGender,
    FilterGrowth,
    FilterBrand,
    FilterViews,
    FilterAge,
    FilterBio,
  },

  data: () => ({
    filterComponents: {
      instagram: [
        "filter-location",
        "filter-language",
        "filter-brand",
        "filter-partnership",
        "filter-interest",
        "filter-gender",
        "filter-age",
        "filter-keywords",
        // "filter-audience-type",
        "filter-look-alike",
        "filter-bio",
        "filter-followers",
        "filter-engagements",
        "filter-reel-views",
        "filter-contacts",
        "filter-growth",
        "filter-last-posted",
        // "filter-account-type",
        "filter-text-tags",
        "filter-audience-credibility-class"
      ],
      youtube: [
        "filter-location",
        "filter-language",
        "filter-gender",
        "filter-age",
        // "filter-audience-type",
        "filter-keywords",
        "filter-look-alike",
        "filter-bio",
        "filter-followers",
        "filter-engagements",
        "filter-views",
        "filter-contacts",
        "filter-growth",
        "filter-last-posted",
        // "filter-official"
      ],
      tiktok: [
        "filter-location",
        "filter-language",
        "filter-gender",
        "filter-age",
        "filter-keywords",
        "filter-look-alike",
        "filter-bio",
        "filter-followers",
        "filter-engagements",
        "filter-views",
        "filter-contacts",
        "filter-growth",
        "filter-last-posted",
        "filter-text-tags",
      ]
    }
  }),

  computed: {
    platformFilters() {
      return this.filterComponents[this.platform]
    }
  }
}
</script>

<style lang="stylus">
.filter-options--influencer-discovery
  .v-icon
    color #373b56 !important

  .filter-title
    color #4c4c4c !important
</style>
